import { useTranslations } from "../../lib/translations"

export function HistoryTab({ agent }) {
  const t = useTranslations()
  // M2.6 placeholder. M3+ pulls the unified audit + change log into a
  // chronological timeline like the bento mockup shows.
  return <div className="cm-tabwrap"><div className="cm-coming-soon">{t("modal.history.empty")}</div></div>
}
